import { Swiper as SwiperClass, Mousewheel, Navigation, Pagination, Autoplay } from "swiper/swiper.esm";
import "swiper/swiper-bundle.min.css";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";

SwiperClass.use([Navigation, Mousewheel, Pagination, Autoplay]);

export const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
